import { render, staticRenderFns } from "./DuplicateButtonSet.vue?vue&type=template&id=2460e058&"
import script from "./DuplicateButtonSet.vue?vue&type=script&lang=js&"
export * from "./DuplicateButtonSet.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateButtonSet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports